import httpService from './httpService';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../../package.json');

enum FeedbackOption {
  BUG = 'BUG',
  FEATURE = 'FEATURE',
}

interface FeedbackData {
  feedback: string;
  option: FeedbackOption;
  appOs: string;
  appVersion: string;
  platformVersion: string;
  userAgent: string;
}

const sendFeedback = async (feedback: string, option: FeedbackOption): Promise<void> => {
  const { userAgent } = navigator;
  const appOs = getOs(userAgent.toLowerCase());
  const appVersion = packageJson.version;
  const platformVersion = getBrowser(userAgent);

  const data: FeedbackData = {
    feedback,
    option,
    appOs,
    appVersion,
    platformVersion,
    userAgent,
  };

  await httpService.post(`/feedback`, data);
};

const getOs = (userAgent: string): string => {
  switch (true) {
    case userAgent.includes('windows'):
      return 'windows';
    case userAgent.includes('mac'):
      return 'macos';
    case userAgent.includes('linux'):
      return 'linux';
    case userAgent.includes('android'):
      return 'android';
    case userAgent.includes('ios'):
      return 'ios';
    default:
      return userAgent;
  }
};

const getBrowser = (userAgent: string): string => {
  if (userAgent.includes('Safari')) {
    if (userAgent.includes('Chrome')) {
      if (userAgent.includes('Edg')) return `Edge${userAgent.split('Edg')[1]}`;
      if (userAgent.includes('OPR')) return `Opera${userAgent.split('OPR')[1]}`;
      return `Chrome${userAgent.split('Chrome')[1].split(' ')[0]}`;
    }
    if (userAgent.includes('Version')) return `Safari${userAgent.split('Version')[1]}`;
  }
  return userAgent;
};

export { FeedbackOption, sendFeedback };
